import React from 'react';
import ItemHelper from "../../services/Menu/services/Item/ItemHelper";
import {RootState} from "../../../reducers";
import {getItems} from "../../services/Menu/reducer";
import {getCart} from "../../services/Cart/reducer";
import {connect} from "react-redux";
import MenuProductModal from "../../pages/Menu/components/Product/MenuProductModal";
import {getStoreConfig} from "../../services/Store/reducer";

interface OwnProps {
    itemId: number;
    show: boolean;
    onHide: () => void;
    preventRemovePromotionOnHide?: boolean;
    onItemAdded?: (itemState: Record<string, any>) => void;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PromotionItemAddModal = ({
                                   items,
                                   itemId,
                                   show,
                                   onHide,
                                   preventRemovePromotionOnHide,
                                   onItemAdded,
                                   config,
                                   setShow
                               }: Props) => {
    const item = ItemHelper.getItem(items, itemId);
    if (!item) return null;

    return (
        <MenuProductModal show={show} config={config} setShow={setShow} item={item} itemGroup={undefined}
                          preventRemovePromotionOnHide={preventRemovePromotionOnHide} onHide={onHide}
                          onItemAdded={onItemAdded}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default connector(PromotionItemAddModal);